<template>
  <div>
    <header-section :title='"Blog"'></header-section>
    <edit-blog v-if="current_status=='create-blog'"></edit-blog>    
    <preview-blog v-else>Prview</preview-blog>

    <div class="button-group">
      <button v-if="current_status=='create-blog'" id="preview-button" @click="set_current_page('preview')" class="btn btn-default"> Xem thử </button>
      <button v-else id="preview-button" @click="set_current_page('create-blog')" class="btn btn-default"> Quay lại </button>
      <button id="preview-button" @click="" class="btn btn-default"> Đăng ký </button>      
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import EditBlog from "./components/Blog/EditBlog.vue";
  import PreviewBlog from "./components/Blog/PreviewBlog.vue";
  import HeaderSection from "./components/Common/HeaderSection.vue";
  export default{
    components: {
      HeaderSection,
      EditBlog,
      PreviewBlog
    },
    data: function(){
      return {
        current_status: 'create-blog'
      }
    },
    computed:{    
      ...mapGetters( 'user', [
          'isAuthenticated'
      ]),
      ...mapState('user',{
      }),
    },
    methods: {
      set_current_page(status){
        this.current_status = status
      } 
    },
  };
</script>
<style lang="scss" scoped>
  .button-group{
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/CreateBlog.vue